export default __webpack_public_path__ + "static/media/Armguards of the Ostiary.8a916857.jpg";